import { MonoTypeOperatorFunction } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import equal from 'fast-deep-equal';

export function distinctUntilChangedObj<T>(): MonoTypeOperatorFunction<T> {
  return distinctUntilChanged<T>((a, b) => equal(a, b));
}